import { Inject, Injectable, NgZone } from '@angular/core';

import { ConsoleLogger, IntervalEndedData, IntervalEvents, IntervalStartedData } from '@skylab-shared/core';

import { EventBus, EventBusBase } from '../event/event-bus.service';

@Injectable({ providedIn: 'root'})
export class IntervalWrapperService {
    private readonly intervals = new Map();
    private readonly logger = new ConsoleLogger(IntervalWrapperService.name);

    public constructor (
        private readonly ngZone: NgZone,
        @Inject(EventBus) private readonly eventBus: EventBusBase
    ) { }

    public run(): void {
        this.observeNewIntervals();
        this.observeDestroyedInterals();
    }

    private observeDestroyedInterals(): void {
        this.eventBus.observe(IntervalEvents.IntervalEnded, (data: IntervalEndedData) => {
            const interval = this.intervals.get(data.actionId);
            clearInterval(interval);

            this.logger.info(`interval outside angular destrotyed: intervalId: ${interval}, actionId: ${data.actionId}`);
        });
    }

    private observeNewIntervals(): void {
        this.eventBus.observe(IntervalEvents.IntervalStarted, (data: IntervalStartedData) => {
            let intervalId: ReturnType<typeof setInterval>;

            this.ngZone.runOutsideAngular(() => {
                intervalId = setInterval(() => {
                    data.action();
                }, data.interval);
            });
            this.intervals.set(data.actionId, intervalId!);

            this.logger.info(`new interval outside angular: intervalId: ${intervalId!}, actionId: ${data.actionId}`);
        });
    }
}
